import React, { ReactElement } from 'react';
import ReactDom from 'react-dom';
import { useTranslation } from 'react-i18next';
import classes from './UIModal.module.scss';
import { Box, Button, Fade, Modal } from '@mui/material';

interface UIModalProps {
  title: string;
  message: string;
  onConfirm: () => void;
  onClosed?: () => void;
  children?: ReactElement;
  show: boolean;
  closable?: boolean;
}
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: '80%',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const UIModal: React.FC<UIModalProps> = ({ title, message, show, closable, onConfirm, onClosed, children }) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(show);
  const handleOpen = () => setOpen(true);
  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (closable) {
      setOpen(false);
      if (onClosed) {
        onClosed();
      }
    }
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Fade in={open}>
        <div>
          <Box sx={{ ...style }}>
            {/* <div className={classes.modal}> */}
            {title ? (
              <header className={classes.header}>
                <h3>{title}</h3>
              </header>
            ) : null}
            <div className={classes.content}>
              <p>{message}</p>
            </div>

            {children}
          </Box>
        </div>
      </Fade>
    </Modal>
  );
};

export default UIModal;
